"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _icon = require("@react-spectrum/icon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const CustomIcon = props => {
  const {
    childClassName,
    size
  } = props;
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(props.url, {
    className: childClassName
  }));
};
CustomIcon.propTypes = {
  childClassName: _propTypes.PropTypes.string,
  size: _propTypes.PropTypes.string
};
CustomIcon.defaultProps = {
  childClassName: "",
  size: "S"
};
var _default = exports.default = CustomIcon;